import MarketingShell from '../components/MarketingShell';

export default function Platform() {
  return (
    <MarketingShell>
      <section className="mk-section">
        <div className="mk-section-head">
          <div className="mk-eyebrow">Platform</div>
          <h2>Everything a programme needs, none of the spreadsheet sprawl</h2>
          <p>Governance, delivery, and finance live in one org &rarr; programme &rarr; project &rarr; workstream hierarchy, with role-based access and settings that inherit and override cleanly at every level.</p>
        </div>
        <div className="mk-pillars-grid">
          <div className="mk-pillar-card">
            <span className="mk-tag mk-tag-gov">Governance</span>
            <h3>Stay ahead of risk</h3>
            <ul><li>Full stage gate lifecycle with RAG status</li><li>RAID log linked to gates and decisions</li><li>Rex drafts risks from the charter</li></ul>
          </div>
          <div className="mk-pillar-card">
            <span className="mk-tag mk-tag-mgmt">Management</span>
            <h3>Plan and report with one dataset</h3>
            <ul><li>Gantt and grid planner with swimlanes</li><li>Resource allocation and demand view</li><li>Weekly status reports, AI-drafted</li></ul>
          </div>
          <div className="mk-pillar-card">
            <span className="mk-tag mk-tag-work">Workbench</span>
            <h3>Design through deploy, chained</h3>
            <ul><li>Requirements to disposition to build</li><li>Unit, integration and UAT tracking</li><li>Every artefact feeds the next</li></ul>
          </div>
          <div className="mk-pillar-card">
            <span className="mk-tag mk-tag-fin">Finance</span>
            <h3>Track the number that matters</h3>
            <ul><li>Budget vs ROM estimate variance</li><li>Reforecast narrative, AI-suggested</li><li>Benefits register and realisation</li></ul>
          </div>
        </div>
      </section>

      <section className="mk-section mk-section-tight">
        <div className="mk-rex-section">
          <div className="mk-eyebrow mk-eyebrow-dark">Rex — your embedded programme assistant</div>
          <h2>Rex proposes, drafts, and analyses. You always confirm.</h2>
          <p>Present across every pillar, Rex chains each artefact it produces into the next — from charter to RAID to status report — grounded in your organisation&apos;s own history, not generic AI output.</p>
          <div className="mk-rex-grid">
            <div className="mk-rex-card"><h4>Company Memory</h4><p>A hierarchical knowledge layer — org, division, programme — that enriches every Rex proposal with your organisation&apos;s own context and lessons learned.</p></div>
            <div className="mk-rex-card"><h4>OOTB scoring</h4><p>A unique metric showing how closely your configuration tracks what the platform delivers natively, so custom build stays a deliberate choice.</p></div>
            <div className="mk-rex-card"><h4>Platform KB</h4><p>A curated, versioned knowledge base per platform — SAP, Dynamics, Manhattan, Oracle — grounding Rex&apos;s drafts in real native behaviour.</p></div>
          </div>
        </div>
      </section>
    </MarketingShell>
  );
}
